import { escapeHtml } from "utils/briefingHtml";

const decodeHtmlEntities = (value) => {
  if (typeof window === "undefined" || !window.document) {
    return value
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&quot;/gi, "\"")
      .replace(/&#039;|&#39;/gi, "'");
  }

  const textarea = window.document.createElement("textarea");
  textarea.innerHTML = value;
  return textarea.value;
};

// Calendar event descriptions are stored as HTML, but the chat widgets edit
// them as plain text. These two helpers convert between the two so the create
// and update widgets share one source of truth.
export const descriptionHtmlToText = (description = "") => {
  if (!/<[a-z][\s\S]*>/i.test(description)) {
    return description;
  }

  const text = description
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<\/li>/gi, "\n")
    .replace(/<[^>]*>/g, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return decodeHtmlEntities(text);
};

export const descriptionToHtml = (description = "") => {
  const trimmedDescription = description.trim();
  if (!trimmedDescription) return "";

  return trimmedDescription
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, "<br>")}</p>`)
    .join("");
};
